type BalanceOperation = 0 | 1;

export const BALANCE_OPERATION: Record<BalanceOperation, string> = {
  '0': 'Списание',
  '1': 'Начисление',
};

export const UPDATE_SUCCESS = 'Баланс бонусного счета обновлен';
export const UPDATE_ERROR = 'Не удалось обновить баланс бонусного счета';
